// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"a8616950","977":"fe4a7f0e"}[chunkId] + ".chunk.js");